import React from "react";
import { withRouter } from "react-router";
import AgregarCupon from "./AgregarCupon";
const EditarCupon = props => {
    return <AgregarCupon editar={true} />;
};

export default withRouter(EditarCupon);
